module.exports = __webpack_public_path__ + "static/media/Continua_Day_HDRI.98673900.hdr";